// Services
const SERVICES = {
  SHOP: 'shop',
  SUBSCRIPTION: 'subscription', // @deprecated
  PROJECTS: 'projects'
};

// Services の enum 用定義
const SERVICES_PATTERN = Object.keys(SERVICES).map((key) => SERVICES[key]);

const REFERENCE_SOURCE = {
  PREMIUM_TURN_ON_AUTO_RENEWAL: 'premium_turn_on_auto_renewal'
};

export {
  SERVICES,
  SERVICES_PATTERN,
  REFERENCE_SOURCE
};
